export default __webpack_public_path__ + "static/intro-tile-7-messaging-platform-3c64f933fd08882a16b8700d8a37af48.jpg";